import Stars from './Stars.vue';

export default Stars;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/review/components/stars/index.ts